import { Controller } from "@hotwired/stimulus"

// Handles inline editing of own chat messages and edit history display.
export default class extends Controller {
  static targets = ["display", "editForm", "history"]
  static values = {
    messageId: Number,
    chatId: Number,
    own: Boolean
  }

  startEdit() {
    if (!this.ownValue) return
    if (this.hasDisplayTarget) this.displayTarget.classList.add("hidden")
    if (this.hasEditFormTarget) {
      this.editFormTarget.classList.remove("hidden")
      const textarea = this.editFormTarget.querySelector("textarea")
      if (textarea) {
        textarea.focus()
        textarea.setSelectionRange(textarea.value.length, textarea.value.length)
      }
    }
  }

  cancel() {
    if (this.hasEditFormTarget) this.editFormTarget.classList.add("hidden")
    if (this.hasDisplayTarget) this.displayTarget.classList.remove("hidden")
  }

  onSaved(event) {
    if (event.detail.success) {
      this.cancel()
    }
  }

  toggleHistory() {
    if (this.hasHistoryTarget) {
      this.historyTarget.classList.toggle("hidden")
    }
  }
}
